export default __webpack_public_path__ + "static/media/image-3.efc4e0c5.webp";